import { render, staticRenderFns } from "./Liquidez.vue?vue&type=template&id=b75580cc&scoped=true&"
import script from "./Liquidez.vue?vue&type=script&lang=js&"
export * from "./Liquidez.vue?vue&type=script&lang=js&"
import style0 from "./Liquidez.vue?vue&type=style&index=0&id=b75580cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75580cc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b75580cc')) {
      api.createRecord('b75580cc', component.options)
    } else {
      api.reload('b75580cc', component.options)
    }
    module.hot.accept("./Liquidez.vue?vue&type=template&id=b75580cc&scoped=true&", function () {
      api.rerender('b75580cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Liquidez/Liquidez.vue"
export default component.exports